module.exports = __webpack_public_path__ + "img/李小玲.c22f52d0.jpg";